export const ARTICLE_CARD_PROPS = {
  title: {
    type: String,
    required: true,
  },
  connectSourceUrl: {
    type: String,
    required: true,
  },
  careTeamDocumentId: {
    type: String,
    required: true,
  },
  category: {
    type: String as () => string | null,
    required: false,
  },
  externalThymeboxPatientId: {
    type: String,
    required: false,
  },
} as const
